import React from 'react';
import './waiting_v2.css';

const waiting = (props) => {
    return (
        <div className="waitingComponent lucky_waiting" style={{height: props.height}}>
            <div class="lds-ellipsis"><div className='special'></div><div className='special'></div><div className='special'></div><div className='special'></div></div>
        </div>        
    );
}

export default waiting;